var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2024(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881 190",
    style: {
      enableBackground: "new 0 0 881 190"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#32adff;;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881,162.9V190h-33.9v-27.1H881z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881,135.7v27.1h-33.9v-27.1H881z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881,108.6v27.1h-33.9v-27.1H881z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881,81.4v27.1h-33.9V81.4H881z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881,54.3v27.2h-33.9V54.3H881z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881,27.2v27.1h-33.9V27.2H881z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881,0v27.2h-33.9V0H881z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.1,162.9V190h-33.9v-27.1H847.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.1,135.7v27.1h-33.9v-27.1H847.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.1,108.6v27.1h-33.9v-27.1H847.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.1,81.4v27.1h-33.9V81.4H847.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.1,54.3v27.2h-33.9V54.3H847.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.1,27.2v27.1h-33.9V27.2H847.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.1,0v27.2h-33.9V0H847.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M813.2,108.6v27.1l-33.9,0v-27.2H813.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M779.3,108.6v27.2h-33.9v-27.2H779.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M779.3,81.4v27.1h-33.9V81.4H779.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M779.3,54.3v27.2h-33.9V54.3H779.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M779.3,27.2v27.1h-33.9V27.2H779.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M779.3,0v27.2h-33.9V0H779.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M745.5,81.4v27.1h-33.9V81.4H745.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M745.5,54.3v27.2h-33.9V54.3H745.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M745.5,27.2v27.1h-33.9V27.2H745.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M745.5,0v27.2h-33.9V0H745.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M643.8,162.9V190h-33.9v-27.1H643.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M643.8,81.4v27.1h-33.9V81.4H643.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M643.8,54.3v27.2h-33.9V54.3H643.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M643.8,27.2v27.1h-33.9V27.2H643.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.9,162.9V190H576v-27.1H609.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.9,108.6l0,27.2H576v-27.2H609.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.9,81.4v27.1H576V81.4H609.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.9,54.3v27.2H576V54.3H609.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.9,27.2v27.1H576V27.2H609.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.9,0l0,27.2H576V0H609.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576,162.9V190h-33.9v-27.1H576z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576,135.7v27.1h-33.9v-27.1L576,135.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576,108.6v27.2l-33.9,0v-27.1H576z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576,0v27.2l-33.9,0V0H576z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.2,162.9V190h-33.9v-27.1H542.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.2,135.7v27.1h-33.9v-27.1H542.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.2,54.3v27.2h-33.9V54.3H542.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.2,27.2l0,27.1h-33.9V27.2L542.2,27.2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.2,0v27.2l-33.9,0V0H542.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.3,162.9V190h-33.9v-27.1H508.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.3,54.3v27.2h-33.9V54.3H508.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.3,27.2v27.1h-33.9V27.2H508.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,135.7v27.1h-33.9v-27.1H406.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,108.6v27.1h-33.9v-27.1H406.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,81.4v27.1h-33.9V81.4H406.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,54.3v27.2h-33.9V54.3H406.6z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,27.2v27.1h-33.9V27.2H406.6z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,162.9l0,27.1h-33.9v-27.1H372.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,135.7v27.1h-33.9v-27.1H372.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,108.6v27.1h-33.9v-27.1H372.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,81.4v27.1h-33.9V81.4H372.7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,54.3v27.2h-33.9V54.3H372.7z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,27.2v27.1h-33.9V27.2H372.7z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,0l0,27.2h-33.9V0H372.7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.8,162.9V190H305v-27.1H338.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.8,0v27.2H305V0H338.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,162.9V190h-33.9v-27.1H305z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,135.7l0,27.1h-33.9v-27.1H305z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,108.6v27.1h-33.9v-27.1H305z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,81.4v27.1h-33.9V81.4H305z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,54.3v27.2h-33.9V54.3H305z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,27.2l0,27.1h-33.9V27.2L305,27.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,0v27.2l-33.9,0V0H305z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,135.7v27.1h-33.9v-27.1H271.1z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,108.6v27.1h-33.9v-27.1H271.1z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,81.4v27.1h-33.9V81.4H271.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,54.3v27.2h-33.9V54.3H271.1z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.1,27.2v27.1h-33.9V27.2H271.1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.4,162.9V190h-33.9v-27.1H169.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.4,81.4v27.1h-33.9V81.4H169.4z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.4,54.3v27.2h-33.9V54.3H169.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.4,27.2v27.1h-33.9V27.2H169.4z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,162.9V190h-33.9v-27.1H135.5z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,108.6l0,27.2h-33.9v-27.2H135.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,81.4v27.1h-33.9V81.4H135.5z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,54.3v27.2h-33.9V54.3H135.5z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,27.2v27.1h-33.9V27.2H135.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,0l0,27.2h-33.9V0H135.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.7,162.9V190H67.8v-27.1H101.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.7,135.7v27.1H67.8v-27.1L101.7,135.7z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.7,108.6v27.2l-33.9,0v-27.1H101.7z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.7,0v27.2l-33.9,0V0H101.7z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,162.9V190H33.9v-27.1H67.8z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,135.7v27.1H33.9v-27.1H67.8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,54.3v27.2H33.9V54.3H67.8z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,27.2l0,27.1H33.9V27.2L67.8,27.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,0v27.2l-33.9,0V0H67.8z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,162.9V190H0v-27.1H33.9z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,54.3v27.2H0V54.3H33.9z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,27.2v27.1H0V27.2H33.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2024);
export default __webpack_public_path__ + "static/media/2024.d14676469b639624434a35e42237ac41.svg";
export { ForwardRef as ReactComponent };